import { render, staticRenderFns } from "./RegimenInfoNew.vue?vue&type=template&id=72f96d2a&scoped=true"
import script from "./RegimenInfoNew.vue?vue&type=script&lang=js"
export * from "./RegimenInfoNew.vue?vue&type=script&lang=js"
import style0 from "./RegimenInfoNew.vue?vue&type=style&index=0&id=72f96d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f96d2a",
  null
  
)

export default component.exports